module.exports = __webpack_public_path__ + "static/media/35.eda7c089.JPG";